import { RutterValidationStatus } from '@40seas/entities/rutter';
import { EnumColor } from '@40seas/frontend/common/providers';

export const RutterValidationStatusMapping = {
    [RutterValidationStatus.Succeeded]: 'success',
    [RutterValidationStatus.Pending]: 'info',
    [RutterValidationStatus.Failed]: 'error',
} as { [key in RutterValidationStatus]: EnumColor };
